import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import "./UbicacionProyecto.scss"
import GenerarAlt from "../../utils/GenerarAlt"

const UbicacionProyecto = ({ direccion, imagen, botones, tituloPage }) => {
  return (
    <section className="ubicacion-seccion">
      <h3 className="none">Mapa {tituloPage}</h3>
      <div className="ubicacion-contenido mwx-1680 mx-auto">
        {imagen && (
          <div className="ubicacion-mapa-col">
            <GatsbyImage
              className="w-100"
              image={imagen?.sourceUrlSharp?.childImageSharp?.gatsbyImageData}
              alt={GenerarAlt(imagen)}
            />
          </div>
        )}
        <div className="ubicacion-info-col">
          {direccion && (
            <div
              className="ubicacion-titulo size-45 font-roboto weight-300"
              dangerouslySetInnerHTML={{ __html: direccion }}
            />
          )}
          {botones && botones.length > 0 && (
            <div className="ubicacion-como-llegar">
              <span className="ubicacion-como-llegar-titulo font-roboto weight-300">
                ¿Cómo llegar?
              </span>
              <div className="ubicacion-botones">
                {botones.map((boton, i) => (
                  <a
                    key={i}
                    className="ubicacion-boton"
                    href={boton?.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {boton?.imagen && (
                      <GatsbyImage
                        className="ubicacion-boton-imagen"
                        image={
                          boton?.imagen.sourceUrlSharp.childImageSharp
                            .gatsbyImageData
                        }
                        alt={GenerarAlt(boton.imagen)}
                      />
                    )}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default UbicacionProyecto
